module.exports = __webpack_public_path__ + "static/media/trt.7919a458.png";